<template>
  <router-link :to="'/posts/' + post.id">
    <div class="article_body">
      <div class="article_image">
        <img
          :src="baseUrl + post.feature"
          alt=""
          width="100%"
          @error="replaceByDefault">
      </div>
      <div class="article_text">
        <div class="article_name">
          {{ post.title }}
        </div>
        <div class="article_content">
          {{ post.description }}
        </div>
        <div class="article_view">
          Xem chi tiết
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import ApiConfig from "../../communicate/ApiConfig";
  import defaultImage from '../../assets/images/default.png';


  export default {
    name: "ArticleItem",

    // eslint-disable-next-line vue/require-prop-types
    props: ["post"],

    data: function () {
      return {
        baseUrl: ApiConfig.base_url
      }
    },
    methods: {
      replaceByDefault(e) {
        e.target.src = defaultImage;
      }
    }
  }
</script>

<style scoped>
  .card-body {
    position: absolute;
    bottom: 0px;
    height: 12%;
  }
  img {
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleItem.vue